/* ============
 * Actions for the module
 * ============
 *
 * The actions that are available on the
 * module.
 */

import {
  DO_APPLY_JOB,
  DO_APPLY_SEARCH,
  DO_APPLY_SEARCH_MAPS,
  DO_GET_DETAIL,
  DO_GET_JOBARRANGEMENT,
  DO_GET_JOBCONTRACT,
  DO_GET_LIST,
  DO_GET_LIST_APPLY,
  DO_GET_LIST_PLAN,
  DO_GET_LIST_RESULT_EMPLOYMENT,
  DO_GET_LIST_RESULT_SALARY,
  DO_GET_LIST_WORK,
  DO_GET_WISH_LIST,
  DO_JOB_TRANSFER_REQUEST,
  DO_RESET_DEFAULT,
  RESET_JOBS,
  SHOW_JOBS,
} from "@actionTypes/jobs";

export function getMeta(payload, params, isLoadMore) {
  return {
    type: DO_GET_LIST,
    payload,
    params,
    isLoadMore,
  };
}

export function getWishList(payload, params) {
  return {
    type: DO_GET_WISH_LIST,
    payload,
    params,
  };
}

export function getListApply(payload, params) {
  return {
    type: DO_GET_LIST_APPLY,
    payload,
    params,
  };
}

export function getListPlan(payload, params) {
  return {
    type: DO_GET_LIST_PLAN,
    payload,
    params,
  };
}

export function getListWork(payload, params) {
  return {
    type: DO_GET_LIST_WORK,
    payload,
    params,
  };
}

export function getListResultEmployment(payload, params) {
  return {
    type: DO_GET_LIST_RESULT_EMPLOYMENT,
    payload,
    params,
  };
}

export function getListResultSalary(payload, params) {
  return {
    type: DO_GET_LIST_RESULT_SALARY,
    payload,
    params,
  };
}

export function getDetail(payload) {
  return {
    type: DO_GET_DETAIL,
    payload,
  };
}

export function doApply(payload) {
  return {
    type: DO_APPLY_JOB,
    payload,
  };
}

export function doApplySearch(payload) {
  return {
    type: DO_APPLY_SEARCH,
    payload,
  };
}

export function doApplySearchMaps(payload) {
  return {
    type: DO_APPLY_SEARCH_MAPS,
    payload,
  };
}

export function getJobContract(payload) {
  return {
    type: DO_GET_JOBCONTRACT,
    payload,
  };
}

export function getJobArrangement(payload) {
  return {
    type: DO_GET_JOBARRANGEMENT,
    payload,
  };
}

export function doJobTransferRequest(payload) {
  return {
    type: DO_JOB_TRANSFER_REQUEST,
    payload,
  };
}

export function showJobs(payload) {
  return {
    type: SHOW_JOBS,
    payload,
  };
}

export function resetJobs(payload = { reset: false }) {
  return {
    type: RESET_JOBS,
    payload,
  };
}

export function resetDefault() {
  return {
    type: DO_RESET_DEFAULT,
  };
}
